export class TimerExpiredError extends Error {
  constructor(message: string = 'Timer expired') {
    super(message);
    this.name = 'TimerExpiredError';
  }
}
